// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021445/js/" + chunkId + "." + {"44":"fb7e830c","225":"699b9fc5","481":"79ce5154","486":"79d35979","770":"f6d50fce"}[chunkId] + ".0.9363566415819526.chunk.js";
};